import React, { useState, useRef } from 'react';
import { Lock } from 'lucide-react';

const ERP_PASSWORD = 'sseeaa';

interface ErpUnlockScreenProps {
    onUnlock: () => void;
}

export const ErpUnlockScreen: React.FC<ErpUnlockScreenProps> = ({ onUnlock }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);
    const [shakeKey, setShakeKey] = useState(0);
    const inputRef = useRef<HTMLInputElement>(null);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (password === ERP_PASSWORD) {
            onUnlock();
        } else {
            setError(true);
            setShakeKey(k => k + 1);
            setPassword('');
            setTimeout(() => inputRef.current?.focus(), 0);
        }
    };

    return (
        <div
            className="fixed inset-0 flex items-center justify-center"
            style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1a2744 50%, #0f172a 100%)' }}
        >
            {/* Subtle dot-grid background */}
            <div
                className="absolute inset-0 pointer-events-none"
                style={{
                    backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.045) 1px, transparent 1px)',
                    backgroundSize: '32px 32px',
                }}
            />

            <div
                key={shakeKey}
                className="relative z-10 w-full max-w-xs mx-6"
                style={shakeKey > 0 ? { animation: 'erp-shake 0.42s ease-in-out' } : undefined}
            >
                {/* Logo + subtitle */}
                <div className="text-center mb-12">
                    <img
                        src="/images/Logo_Color.svg"
                        alt="SSEEAA"
                        className="h-6 mx-auto mb-5"
                        style={{ filter: 'brightness(0) invert(1)', opacity: 0.8 }}
                    />
                    <p
                        className="text-xs tracking-[0.3em] uppercase"
                        style={{ color: 'rgba(148,163,184,0.6)' }}
                    >
                        Management System
                    </p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="relative mb-3">
                        <Lock
                            className="absolute left-4 top-1/2 -translate-y-1/2 w-3.5 h-3.5"
                            style={{ color: 'rgba(100,116,139,0.8)' }}
                        />
                        <input
                            ref={inputRef}
                            type="password"
                            value={password}
                            onChange={(e) => { setPassword(e.target.value); setError(false); }}
                            placeholder="访问密码"
                            autoFocus
                            autoComplete="current-password"
                            className="w-full rounded-xl py-3.5 pl-11 pr-4 text-sm text-white placeholder-slate-600 outline-none transition-all duration-200"
                            style={{
                                background: 'rgba(255,255,255,0.05)',
                                border: `1px solid ${error ? 'rgba(239,68,68,0.45)' : 'rgba(255,255,255,0.07)'}`,
                                caretColor: 'white',
                            }}
                            onFocus={(e) => {
                                if (!error) e.target.style.borderColor = 'rgba(255,255,255,0.18)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = error ? 'rgba(239,68,68,0.45)' : 'rgba(255,255,255,0.07)';
                            }}
                        />
                    </div>

                    {error && (
                        <p className="text-red-400 text-xs text-center mb-3">密码不正确，请重试</p>
                    )}

                    <button
                        type="submit"
                        className="w-full py-3.5 rounded-xl text-sm font-medium transition-all duration-200 mt-1"
                        style={{ background: 'rgba(255,255,255,0.92)', color: '#0f172a' }}
                        onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.background = 'rgba(255,255,255,1)'; }}
                        onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.background = 'rgba(255,255,255,0.92)'; }}
                    >
                        进入系统
                    </button>
                </form>
            </div>

            <style>{`
                @keyframes erp-shake {
                    0%, 100% { transform: translateX(0); }
                    15%       { transform: translateX(-9px); }
                    35%       { transform: translateX(9px); }
                    55%       { transform: translateX(-5px); }
                    75%       { transform: translateX(5px); }
                }
            `}</style>
        </div>
    );
};
